import { supabase } from '../lib/supabase';
import { parseDateOnly } from '../utils/formatters';

export interface HistoricoMensual {
  mes: number;
  año: number;
  aportes_mensuales: number;
  cuota_iglesia: number;
  total_recaudado: number;
}


export const cuotaIglesiaService = {
  async getTotalRecaudado(lumisialId: string, fechaInicio?: string, fechaFin?: string): Promise<number> {
    let query = supabase
      .from('movimientos')
      .select('monto')
      .eq('lumisial_id', lumisialId)
      .eq('tipo', 'ingreso')
      .eq('origen_tipo', 'miembro')
      .eq('categoria_aporte', 'cuota_iglesia')
      .eq('anulado', false);

    if (fechaInicio) {
      query = query.gte('fecha', fechaInicio);
    }

    if (fechaFin) {
      query = query.lte('fecha', fechaFin);
    }

    const { data, error } = await query;

    if (error) throw error;

    return data?.reduce((sum, m) => sum + Number(m.monto), 0) || 0;
  },

  async getHistoricoMensual(lumisialId: string, año: number): Promise<HistoricoMensual[]> {
    const fechaInicio = `${año}-01-01`;
    const fechaFin = `${año}-12-31`;

    const { data: movimientos, error } = await supabase
      .from('movimientos')
      .select('fecha, monto, tipo, origen_tipo, categoria_aporte')
      .eq('lumisial_id', lumisialId)
      .eq('tipo', 'ingreso')
      .eq('origen_tipo', 'miembro')
      .eq('anulado', false)
      .gte('fecha', fechaInicio)
      .lte('fecha', fechaFin);

    if (error) throw error;

    const historicoMap: { [key: string]: HistoricoMensual } = {};

    for (let mes = 1; mes <= 12; mes++) {
      const key = `${año}-${mes}`;
      historicoMap[key] = {
        mes,
        año,
        aportes_mensuales: 0,
        cuota_iglesia: 0,
        total_recaudado: 0
      };
    }

    movimientos?.forEach(mov => {
      const fecha = parseDateOnly(mov.fecha);
      const mes = fecha.getMonth() + 1;
      const key = `${año}-${mes}`;

      if (historicoMap[key]) {
        const monto = Number(mov.monto);

        if (mov.categoria_aporte === 'aporte_mensual') {
          historicoMap[key].aportes_mensuales += monto;
        } else if (mov.categoria_aporte === 'cuota_iglesia') {
          historicoMap[key].cuota_iglesia += monto;
        }

        historicoMap[key].total_recaudado += monto;
      }
    });

    return Object.values(historicoMap).sort((a, b) => a.mes - b.mes);
  },

};
